import { Controller, FieldErrors, Control } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import { InputBaseComponentProps, SxProps, Theme } from "@mui/material";

export default function NumberInput(props: {
  fieldName: string;
  label: string;
  control: Control<any, any>;
  errors: FieldErrors<any>;
  fontSize?: number;
  width?: number | string;
  size?: "small" | "medium";
  style?: React.CSSProperties;
  sx?: SxProps<Theme>;
  inputProps?: InputBaseComponentProps;
}) {
  const { fieldName, control, fontSize, errors, width, label, sx, inputProps } =
    props;
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  );
  useEffect(() => {
    setErrorMessage(getNestedValue(errors, fieldName)?.message ?? undefined);
  }, [errors, fieldName]);
  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => (
        <TextField
          style={props.style}
          size="small"
          sx={{
            width: width ?? "120px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
            },
            ...sx,
          }}
          inputProps={{
            style: {
              fontSize: fontSize ?? 16,
            },
            ...inputProps,
          }}
          FormHelperTextProps={{
            style: { color: "red" },
          }}
          InputLabelProps={{
            style: { fontSize: fontSize ?? 16 },
          }}
          value={field.value ?? ""}
          onChange={(e) => {
            field.onChange(e);
          }}
          type="number"
          label={label}
          error={!!errors[fieldName]}
          helperText={errorMessage}
        />
      )}
    />
  );
}
export function getNestedValue(obj: any, index: string): any | undefined {
  const keys = index.split(".");
  let value = obj;

  for (const key of keys) {
    if (value && value.hasOwnProperty(key)) {
      value = value[key];
    } else {
      return undefined;
    }
  }

  return value;
}
